import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AffiliateService } from '../services/affiliate.service';

export const affiliateAuthGuard: CanActivateFn = () => {
  const affiliateService = inject(AffiliateService);
  const router = inject(Router);

  if (affiliateService.isAuthenticated()) {
    return true;
  }

  router.navigate(['/affiliates/login']);
  return false;
};
